import { render } from "./PackageCanvas.vue?vue&type=template&id=1e3736b2&scoped=true&ts=true"
import script from "./PackageCanvas.vue?vue&type=script&lang=ts"
export * from "./PackageCanvas.vue?vue&type=script&lang=ts"

import "./PackageCanvas.vue?vue&type=style&index=0&id=1e3736b2&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3736b2"]])

export default __exports__